<template>
    <div class="flex items-center justify-center w-full bg-blue-200 text-blue-700 text-center leading-tight py-3 px-3 sm:text-md">
        <div>
            <span class="font-bold">Welcome!</span> You have 1 free trial transaction.
        </div>

        <a v-if="! on_payment_route"
            :href="payment_route || '/broker/settings/billing'"
        >
            <button-blue type="button" class="ml-6" size="small">
                Subscribe For Unlimited Transactions
            </button-blue>
        </a>

        <span v-else>
            &nbsp;Submit your payment to unlock unlimited transactions.
        </span>
    </div>
</template>

<script>
import ButtonBlue from '../components/button-blue.vue';

export default {
    components: {
        ButtonBlue,
    },

    props: {
        payment_route: {},
        on_payment_route: { default: false },
    },
}
</script>
